<template>
  <v-flex xs12 class="text-xs-center" v-if="$store.state.contractors.loadingContractors">
    <v-progress-circular indeterminate :color="$store.state.global.pages[$route.name].color"></v-progress-circular>
  </v-flex>
  <transition name="fadeToggle" mode="out-in" v-else>
    <v-flex xs12 v-if="listView">
      <v-card hover>
        <v-data-table
          :items="filteredContractors"
          :headers="headers"
          :rows-per-page-items="itemsPerPageOptions"
        >
          <template slot="items" slot-scope="props">
            <table-row
              :headers="headers"
              :row="props.item"
              parent="Contractor"
              :key="props.item.id"
            ></table-row>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>

    <transition-group name="data-list" tag="layout-no-padding" v-else>
      <v-flex
        xs12
        sm6
        md4
        xl3
        v-for="(contractor,i) in filteredContractors.slice(0, 16)"
        :key="contractor.id"
        class="data-list-item"
      >
        <contractor-card :contractor="contractor" :index="i"></contractor-card>
      </v-flex>
    </transition-group>
  </transition>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import ContractorService from '@/services/requests/contractorService'
import ContractorCard from '@/components/contractors/contractorCard'
import TableRow from '@/components/ui/masterFileTableRow'

export default {
  data() {
    return {
      headers: [
        {
          text: 'Name',
          align: 'left',
          value: 'name',
        },
        {
          text: 'Contact Email',
          align: 'left',
          value: 'contactEmail',
        },
        {
          text: 'ContactPhone',
          align: 'left',
          value: 'contactPhone',
        },
        {
          text: 'ABN',
          align: 'left',
          value: 'abn',
        },
        {
          text: 'Compliance Resources',
          align: 'right',
          value: 'complianceCount',
        },
        {
          text: 'Actions',
          align: 'center',
          sortable: false,
        },
      ],
    }
  },
  computed: {
    sortBy: Store.getSet({ store: 'contractors', prop: 'sortBy' }),
    filterBy: Store.getSet({ store: 'contractors', prop: 'filterBy' }),
    contractors: Store.getSet({ store: 'contractors', prop: 'contractors' }),
    listView: Store.getSet({ store: 'contractors', prop: 'listView' }),
    showInactive: Store.getSet({ store: 'contractors', prop: 'showInactive' }),
    selectedRecordType: Store.getSet({
      store: 'contractors',
      prop: 'selectedRecordType',
    }),
    sortedContractors() {
      if (this.sortBy) {
        var path = this.sortBy
        return this.contractors.sort((a, b) => {
          if (this.getObjectPath(path, a) < this.getObjectPath(path, b)) {
            if (path == 'updatedAt') {
              return 1
            }
            return -1
          } else {
            if (path == 'updatedAt') {
              return -1
            }
            return 1
          }
        })
      } else {
        return this.contractors
      }
    },
    filteredContractors() {
      return this.sortedContractors.filter((contractor) => {
        const searchMatch =
          contractor.name.toLowerCase().indexOf(this.filterBy.toLowerCase()) >
          -1
        if (this.selectedRecordType === 'Inactive')
          return searchMatch && !contractor.active
        else if (this.selectedRecordType === 'Request')
          return searchMatch && contractor.request
        else return searchMatch && contractor.active && !contractor.request
      })
    },
  },
  components: {
    ContractorCard,
    TableRow,
  },
}
</script>

<style scoped>
</style>
